import { useCallback } from 'react'

import { Country, EmployeeLevelEnum } from '../../../types'
import { useEmployeeLevelsByCountry } from './useEmployeeLevelsByCountry'
import { ApolloError } from '@apollo/client'

export const useEmployeeLevels = (
  country: Country,
): {
  employeeLevels: EmployeeLevelEnum[] | null
  hasEmployeeLevel: (employeeLevel: EmployeeLevelEnum) => boolean
  loading: boolean
  error: ApolloError | undefined
} => {
  const { data, loading, error } = useEmployeeLevelsByCountry(country)

  const hasEmployeeLevel = useCallback(
    (employeeLevel: EmployeeLevelEnum) => {
      return !!data && !!data.employeeLevels ? data.employeeLevels.includes(employeeLevel) : false
    },
    [data],
  )

  return { employeeLevels: !!data ? data.employeeLevels : null, hasEmployeeLevel, loading, error }
}
